import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFullPageLoading = props => _jsxs("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, props), {}, {
  children: [_jsx("path", {
    fill: "none",
    d: "M0 0h100v100H0z"
  }), _jsx("g", {
    transform: "translate(84 50)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(45 -52.355 126.397)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.12s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.12s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(90 -17 67)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.25s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.25s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(135 -2.355 42.397)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.37s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.37s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(180 8 25)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.5s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.5s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(-135 18.355 7.603)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.62s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.62s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(-90 33 -17)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.75s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.75s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  }), _jsx("g", {
    transform: "rotate(-45 68.355 -76.397)",
    children: _jsxs("circle", {
      r: 8,
      fill: "#3c868b",
      children: [_jsx("animate", {
        attributeName: "opacity",
        from: 1,
        to: 0.1,
        begin: "0.87s",
        dur: "1s",
        repeatCount: "indefinite"
      }), _jsx("animateTransform", {
        attributeName: "transform",
        type: "scale",
        from: 1.4,
        to: 1,
        begin: "0.87s",
        dur: "1s",
        repeatCount: "indefinite"
      })]
    })
  })]
}));
export default SvgFullPageLoading;